module.exports = __webpack_public_path__ + "static/media/صيّن-removebg-preview.c00362f8.png";